import React from 'react';
import styled from 'styled-components';

import { theme } from '../../theme';
import { baseButtonStyles, getIconSize } from './button.styles';
import { ButtonSizeEnum, IButton, IconPositionEnum } from './button.types';

const StyledButton = styled.button<IButton>`
	${baseButtonStyles};
	font-family: ${theme.typography.fonts.semibold};
	flex-direction: ${(props) =>
		props.iconPosition && props.iconPosition === IconPositionEnum.LEFT ? `row-reverse` : ``};
`;

export const Button: React.FunctionComponent<IButton> = (props) => {
	if (props.icon) {
		const iconSize = getIconSize(props.size || ButtonSizeEnum.MEDIUM);
		return (
			<React.Fragment>
				<StyledButton {...props}>
					{props.children} <props.icon size={iconSize} />
				</StyledButton>
			</React.Fragment>
		);
	}
	return (
		<StyledButton {...props} type={props.type || 'button'}>
			{props.children}
		</StyledButton>
	);
};
